import useValidationSchema from 'hooks/useValidationSchema';

import validationSchema from './validationSchema';

export function useMiscDetails() {
  const validate = useValidationSchema(validationSchema);

  return {
    validate,
  };
}
